import { useCallback } from 'react'

import { useConfiguration } from '../../api/internal'

export const useHomePathFromConfig = () => {
  const { data } = useConfiguration()
  const homepagePath = useCallback(
    (configurationName: string) => {
      const configFields = data?.configs.find((e) => e.name === configurationName)
      if (!configFields) {
        return window.location.pathname
      }
      const authorizerServiceUrl = configFields.authorizerServiceUrl
      const directoryServiceUrl = configFields.directoryServiceUrl
      const directoryReaderServiceUrl = configFields.directoryReaderServiceUrl
      const directoryModelServiceUrl = configFields.directoryModelServiceUrl
      return authorizerServiceUrl
        ? '/ui/authorizer/modules'
        : directoryServiceUrl || directoryModelServiceUrl || directoryReaderServiceUrl
          ? '/ui/directory/model'
          : '/ui/settings'
    },
    [data?.configs]
  )

  return { homepagePath }
}
